import { useRouter } from 'next/router';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { isPhoneVerificationPromptRouteEligible } from '@/shared/features/phone-verification/utils';
import { usePhoneVerificationBannerModal } from '../hooks';
export const PhoneVerificationBannerModalGate = () => {
  const router = useRouter();
  const isInExternalPlatform = useIsInExternalPlatform();
  const force = router.query.trialSource === 'signup';
  const isEnabled = isPhoneVerificationPromptRouteEligible({
    isInExternalPlatform,
    pathname: router.pathname
  });
  usePhoneVerificationBannerModal({
    enabled: isEnabled,
    force,
    source: force ? 'signup' : 'banner_modal',
    onDismiss: async () => {
      if (!force) return;
      const {
        trialSource: _,
        ...query
      } = router.query;
      await router.replace({
        pathname: router.pathname,
        query
      }, undefined, {
        shallow: true
      });
    }
  });
  return null;
};